// Module
var code = "<template> <p> Det blir døgnåpen kiosk, hvor det vil selges bla. energidrikk, brus, vann, sjokolade, snop og chips. Det vil også bli solgt både varm- og kaldmat, slik at du skal slippe å gå sulten. </p> </template> ";
// Exports
export default code;